module.exports = __webpack_public_path__ + "kudos_64.svg?95a57896e336da18cbe75bc1072dc2d4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_64.svg
// module id = 166
// module chunks = 0